import React from 'react';
import ContentLoader from 'react-content-loader';

const ProgramDetailLoader = () => (
  <ContentLoader style={{ width: "100%" }} />
  // <ContentLoader
  //   speed={2}
  //   width={400}
  //   height={160}
  //   viewBox="0 0 400 160"
  //   backgroundColor="#f3f3f3"
  //   foregroundColor="#ecebeb"
  // >
  //   <circle cx="44" cy="43" r="41" />
  //   <rect x="124" y="9" rx="0" ry="0" width="307" height="9" />
  //   <rect x="124" y="56" rx="0" ry="0" width="307" height="9" />
  //   <rect x="124" y="75" rx="0" ry="0" width="307" height="9" />
  //   <rect x="124" y="93" rx="0" ry="0" width="307" height="9" />
  //   <rect x="126" y="111" rx="0" ry="0" width="307" height="9" />
  //   <rect x="124" y="131" rx="0" ry="0" width="307" height="9" />
  //   <rect x="124" y="151" rx="0" ry="0" width="307" height="9" />
  // </ContentLoader>
);

export default ProgramDetailLoader;
